import { ArrowRight, ArrowUpRight } from 'lucide-react'

import Button from '/react4xp/components/prototype/Button'
import EventCard from '/react4xp/components/prototype/EventCard'

import type { UpcomingEventsProps } from './types'

export default function UpcomingEvents({ overline, title, events = [], viewAllLink }: UpcomingEventsProps) {
	const viewAllButton = viewAllLink && (
		<Button
			variant="link"
			href={viewAllLink.url}
			isExternal={viewAllLink.isExternal}
		>
			{viewAllLink.text}
			{viewAllLink.isExternal ? (
				<ArrowUpRight className="h-[1lh] w-5 shrink-0" aria-hidden="true" />
			) : (
				<ArrowRight className="h-[1lh] w-5 shrink-0" aria-hidden="true" />
			)}
		</Button>
	)

	return (
		<section className="my-16">
			<div className="container">

				<div className="flex items-start justify-between gap-8">
					<div className="flex flex-col">
						{overline && <p className="body text-black-950">{overline}</p>}
						{title && <h2 className="h2 text-black-950 max-w-175">{title}</h2>}
					</div>

					{viewAllLink && (
						<span className="hidden lg:flex shrink-0">
							{viewAllButton}
						</span>
					)}
				</div>

				<div className="flex flex-col gap-8 mt-12">
					{events.map((event, i) => (
						<EventCard key={i} {...event} />
					))}
				</div>

				{viewAllLink && (
					<span className="flex lg:hidden mt-8">
						{viewAllButton}
					</span>
				)}

			</div>
		</section>
	)
}
